<template>
  <div
    class="flex h-full w-full flex-col justify-between overflow-y-auto p-6"
    data-cy="metadata-form"
  >
    <div class="flex flex-col gap-4">
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-400">
          {{ $t("DEALS.TRACKING.METADATA_KEY") }}
        </label>
        <lf-input
          :placeholder="$t('DEALS.TRACKING.METADATA_KEY')"
          :value="formData.key"
          :show-label="false"
          name="metadata_key"
          data-cy="metadata-key-input"
          @key-released="formData.key = $event"
        />
      </div>
      <div>
        <label class="mb-1 block text-xs font-medium text-gray-400">
          {{ $t("DEALS.TRACKING.METADATA_VALUE") }}
        </label>
        <lf-auto-size-text-area
          v-model="formData.value"
          name="metadata_value"
          :rows="3"
          class="w-full rounded-sm border border-gray-200 px-2.5 py-2 text-sm placeholder-gray-400 outline-none hover:border-gray-300 focus:border-primary focus:ring-0"
          data-cy="metadata-value-input"
        />
      </div>
    </div>
    <div class="flex justify-end gap-2">
      <button
        v-if="showDelete"
        class="mr-auto rounded-md border border-red-200 px-4 py-2 text-sm text-red-500 hover:bg-red-50"
        data-cy="metadata-delete-btn"
        @click="$emit('delete')"
      >
        {{ $t("COMMON.DELETE") }}
      </button>
      <button
        class="rounded-md border border-gray-200 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50"
        data-cy="metadata-form-cancel"
        @click="$emit('cancel')"
      >
        {{ $t("COMMON.CANCEL") }}
      </button>
      <button
        class="rounded-md bg-primary px-4 py-2 text-sm text-white disabled:opacity-50"
        :disabled="isSaveDisabled"
        data-cy="metadata-form-save"
        @click="onSave"
      >
        {{ $t("COMMON.SAVE") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";

import LfAutoSizeTextArea from "@/components/ui/inputs/LfAutoSizeTextArea.vue";

const { initialKey, initialValue, showDelete, saving } = defineProps<{
  initialKey?: string;
  initialValue?: string;
  showDelete?: boolean;
  saving?: boolean;
}>();

const emit = defineEmits<{
  save: [payload: { key: string; value: string }];
  cancel: [];
  delete: [];
}>();

const formData = ref({ key: initialKey ?? "", value: initialValue ?? "" });

const isSaveDisabled = computed(
  () => !formData.value.key.trim() || !formData.value.value.trim() || saving
);

const onSave = () => {
  if (isSaveDisabled.value) {
    return;
  }
  emit("save", {
    key: formData.value.key.trim(),
    value: formData.value.value.trim(),
  });
};
</script>
